const APP = 'application'
const APPTYPE = 'applicationtype'
const FIELD = 'field'
const FLOW = 'flow'
const GROUP = 'group'
const MANUFACTURER = 'manufacturer'
const SERVICE = 'service'
const SUBJECT = 'subject'
const TABLE = 'table'
const USER = 'user'
const MANATEESETTINGS = 'manatee_settings'
const RESTRICTIONS = 'flow_restrictions'
const HUB = 'hub'
const ESTERO_ALERT = 'estero_alert'
const ESTERO_ALERT_LOG = 'estero_alert_log'

export default {
  APP,
  APPTYPE,
  FIELD,
  FLOW,
  GROUP,
  MANUFACTURER,
  SERVICE,
  SUBJECT,
  TABLE,
  USER,
  MANATEESETTINGS,
  RESTRICTIONS,
  HUB,
  ESTERO_ALERT,
  ESTERO_ALERT_LOG
}

export function toI18nKey(typename) {
  // Most typenames are equal to their corresponding locale key
  switch (typename) {
    case APPTYPE:
      return 'APPLICATION_TYPE'
    case MANATEESETTINGS:
      return 'MANATEE_SETTINGS'
    case RESTRICTIONS:
      return 'RESTRICTION'
    default:
      return typename.toUpperCase()
  }
}
